import { Flow } from "src/api/flowTypes";
import { flowFolderScope } from "src/hooks/useCapabilities/flowFolderScope";
import { JobScope } from "src/hooks/useCapabilities/types";
import { Job } from "src/jobs/types";

export const jobScope = (
  flow: Pick<Flow, "flow_folder_id"> | null | undefined,
  job: Pick<Job, "status"> | null | undefined,
): JobScope => ({
  folder: flowFolderScope(flow),
  isActive: job?.status === "active",
});
